<div class="w-full h-full flex flex-col overflow-hidden" style="height: 80vh;">
  <div class="flex items-center justify-between px-4 py-2 border-b">
    <h4 class="text-sm font-sans font-medium truncate">{{ media.caption }}</h4>
    <div class="flex items-center gap-3">
      <button type="button" class="text-xs text-primary" (click)="downloadFile()">
        <i class="fas fa-download pr-1"></i>Download
      </button>
      <button type="button" (click)="close()" aria-label="Close">
        <mat-icon class="text-lg c-fa" svgIcon="c:x"></mat-icon>
      </button>
    </div>
  </div>
  <div class="flex-1 overflow-hidden">
    @if (previewIsEmbeddable && previewEmbedUrl) {
      <iframe [src]="previewEmbedUrl" class="w-full h-full border-0"></iframe>
    } @else {
      <div class="w-full h-full flex flex-col items-center justify-center gap-3">
        <p class="text-sm text-gray-500">Preview isn't available for this file type.</p>
        <button type="button" class="text-primary text-sm underline" (click)="downloadFile()">
          Download {{ media.caption }}
        </button>
      </div>
    }
  </div>
</div>
